import type { PrivacyRequestSummary } from "@kuroo/contracts";

export type SdkPrivacyContext = {
  baseUrl: string;
  request: <T>(path: string, init?: RequestInit) => Promise<T>;
};

export function requestPrivacyExport(context: SdkPrivacyContext): Promise<{ id: string; kind: "export"; status: string }> {
  return context.request<{ id: string; kind: "export"; status: string }>("/api/v1/privacy/export", { method: "POST", body: "{}" });
}

export function requestPrivacyErasure(context: SdkPrivacyContext): Promise<{ id: string; kind: "erasure"; status: string }> {
  return context.request<{ id: string; kind: "erasure"; status: string }>("/api/v1/privacy/erase", { method: "POST", body: JSON.stringify({ confirm: "ERASE_MY_DATA" }) });
}

export function privacyRequests(context: SdkPrivacyContext): Promise<PrivacyRequestSummary[]> {
  return context.request<PrivacyRequestSummary[]>("/api/v1/privacy/requests");
}

export function privacyRequestDownloadUrl(context: SdkPrivacyContext, requestId: string): string {
  return `${context.baseUrl}/api/v1/privacy/requests/${encodeURIComponent(requestId)}/download`;
}
